<template>
  <div class="banner" @mouseover="carouselStop" @mouseleave="carouselStart">
    <div class="carousel-tabs">
      <transition name="tab">
        <div class="tab-item" :style="{ backgroundImage: `url('${require(`@/assets/img/home/Banner/background_xjjhypt.png`)}')` }" :key="0" v-if="activeIndex === 0">
          <div class="content-center">
            <div class="tab-title">新基建<span class="text-primary">行业</span>平台</div>
            <div class="tab-subtitle">开放协同，成就卓越伙伴</div>
            <div class="link-bar">
              <div class="primary-btn" @click="openDashboard">进入易隆创平台</div>
            </div>
          </div>
        </div>
        <div class="tab-item" :style="{ backgroundImage: `url('${require(`@/assets/img/home/Banner/background_ylcsdst.png`)}')` }" :key="1" v-if="activeIndex === 1">
          <div class="content-center">
            <div class="tab-title">易隆创·<span class="text-primary">四</span>大生态</div>
            <div class="tab-subtitle">构建自我进化的行业生态</div>
            <div class="link-bar">
              <div class="primary-btn" @click="goEcosystem">立即查看</div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div class="carousel-navs">
      <div class="nav-item" :class="{'active': activeIndex === 0}" @click="handleNavClick(0)">新基建行业平台</div>
      <div class="nav-item" :class="{'active': activeIndex === 1}" @click="handleNavClick(1)">易隆创四大生态</div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      activeIndex: 0,
      timer: null,
    }
  },
  computed: mapGetters(['isLoggIn']),
  mounted() {
    this.initCarousel();
  },
  methods: {
    ...mapActions(['setLoginPopup', 'setLoginCallback']),
    initCarousel() {
      if (this.timer) clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.activeIndex++;
        if (this.activeIndex >= 2) this.activeIndex = 0;
      }, 3000);
    },
    carouselStop() {
      if (this.timer) clearInterval(this.timer);
    },
    carouselStart() {
      this.initCarousel();
    },
    handleNavClick(index) {
      this.activeIndex = index;
    },
    openDashboard() {
      if (this.isLoggIn) window.open(process.env.VUE_APP_URL + '#/dashboard', '_blank');
      else {
        this.setLoginPopup(true);
        this.setLoginCallback(() => {
          window.open(process.env.VUE_APP_URL + '#/dashboard', '_blank');
        });
      }
    },
    goEcosystem() {
      this.$router.push({ path: '/ecosystem' });
    }
  }
};
</script>

<style lang="less" scoped>
.banner {
  position: relative;
  .carousel-tabs {
    width: 100%;
    height: 460px;
    overflow: hidden;
    position: relative;
    .tab-enter-active {
      transition: all 0.4s ease;
    }
    .tab-leave-active {
      transition: all 0.4s ease;
    }
    .tab-enter {
      transform: translateX(30%);
      opacity: 0;
    }
    .tab-leave-to {
      transform: translateX(-30%);
      opacity: 0;
    }

    .tab-item {
      width: 100%;
      height: 100%;
      padding-bottom: 20px;
      background-size: cover;
      background-position: center;
      position: absolute;
      top: 0;
      left: 0;
      .content-center {
        display: flex;
        flex-direction: column;
        justify-content: center;
        .tab-title {
          font-family: @font-bold;
          font-size: 36px;
          line-height: 65px;
          letter-spacing: 10px;
        }
        .tab-subtitle {
          margin-top: 16px;
          font-size: 24px;
          color: @info-color;
          line-height: 47px;
          letter-spacing: 6px;
        }
        .link-bar {
          margin-top: 33px;
          display: flex;
          .primary-btn,
          .primary-plain-btn {
            width: 185px;
          }
        }
      }
    }
  }
  .carousel-navs {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 26px;
    .nav-item {
      font-family: @font-medium;
      font-size: 16px;
      color: #666;
      cursor: pointer;
      user-select: none;
      transition: color 0.3s ease;
      &:hover {
        color: @primary-color;
      }
      &.active {
        color: @primary-color;
        position: relative;
        &::after {
          content: '';
          width: 100%;
          height: 1px;
          background-color: @primary-color;
          position: absolute;
          bottom: -4px;
          left: 0;
        }
      }
      & + .nav-item {
        margin-left: 40px;
      }
    }
  }
}
</style>
